document.addEventListener("DOMContentLoaded", function() {
    let currentPage = 1;
    const limit = 12; // Number of posts per page

    function fetchData(page) {
        // Show skeleton elements
        document.querySelectorAll('.skeleton').forEach(skeleton => {
            skeleton.style.display = 'block';
        });

        fetch(`https://igcozy-6080a50dd8e9.herokuapp.com/api/get-data?page=${page}&limit=${limit}&sort=-timestamp`)
            .then(response => response.json())
            .then(data => {
                const container = document.getElementById('api-data-container');
                container.innerHTML = ''; // Clear previous data

                if (data) {
                    // Sort the data based on timestamp (latest to oldest)
                    data.data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

                    data.data.forEach(item => {
                        const postCard = document.createElement('div');
                        postCard.className = 'post-card';

                        const postDiv = document.createElement('div');
                        postDiv.className = 'post';

                        const user = document.createElement('p');
                        user.textContent = item.username;
                        user.className = 'user';

                        let mediaElement;
                        if (item.media_type === 'IMAGE') {
                            mediaElement = document.createElement('img');
                            mediaElement.src = item.media_url;
                            mediaElement.alt = item.caption;
                        } else if (item.media_type === 'VIDEO') {
                            mediaElement = document.createElement('video');
                            mediaElement.src = item.media_url;
                            mediaElement.controls = true;
                            mediaElement.poster = item.thumbnail_url; // Set the actual thumbnail image
                        } else if (item.media_type === 'CAROUSEL_ALBUM') {
                            mediaElement = document.createElement('img');
                            mediaElement.src = item.thumbnail_url || item.media_url; // Use thumbnail if available
                            mediaElement.alt = item.caption;
                        }

                        const caption = document.createElement('p');
                        caption.textContent = item.caption || 'COZY';
                        caption.className = 'caption';

                        const viewButton = document.createElement('a');
                        viewButton.textContent = 'View on Instagram';
                        viewButton.href = item.permalink;
                        viewButton.target = '_blank';
                        viewButton.className = 'view-button';

                        postDiv.appendChild(user);
                        postDiv.appendChild(mediaElement);
                        postDiv.appendChild(caption);
                        postDiv.appendChild(viewButton);

                        postCard.appendChild(postDiv);
                        container.appendChild(postCard);
                    });

                    // Update pagination controls
                    document.getElementById('current-page').textContent = data.page;
                    document.getElementById('prev-page').disabled = data.page <= 1;
                    document.getElementById('next-page').disabled = data.page >= data.totalPages;

                    // Hide skeleton elements
                    document.querySelectorAll('.skeleton').forEach(skeleton => {
                        skeleton.style.display = 'none';
                    });
                } else {
                    console.error('No data available');
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }

    document.getElementById('prev-page').addEventListener('click', function() {
        if (currentPage > 1) {
            currentPage--;
            fetchData(currentPage);
        }
    });

    document.getElementById('next-page').addEventListener('click', function() {
        currentPage++;
        fetchData(currentPage);
    });

    // Initial fetch
    fetchData(currentPage);
});
